import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AgGrid, gridConstants as gc, filters } from '../../AgGrid';
import classnames from 'classnames';

// SERVICES
import { getAllQaUsers } from '../../../services';

const styles = theme => ({});

export const QaUsersGrid = withStyles(styles)(props => {
  const [gridData, setGridData] = useState(null);

  const columnDefinitions = [
    { headerName: 'Name', field: 'name' },
    { headerName: 'Code', field: 'code', width: 100 },
    { headerName: 'E-mail', field: 'email' },
    { headerName: 'Address', field: 'address' },
    { headerName: 'City', field: 'city' },
    { headerName: 'State', field: 'state' },
    { headerName: 'Zip', field: 'zip' },
    { headerName: 'Home Phone', field: 'homePhone' },
    { headerName: 'Work Phone', field: 'workPhone' },
    { headerName: 'Record Type', field: 'recordType', width: 150 },
    {
      headerName: 'Process Cancellations',
      field: 'canProcessCancel',
      width: 175,
      filter: filters.set,
      filterParams: {
        values: [true, false, null],
        valueFormatter: params =>
          params.value === true ? 'Yes' : params.value === false ? 'No' : 'Not Set',
      },
      valueFormatter: ({ value }) => (value === true ? 'Yes' : value === false ? 'No' : ''),
      boolean: true,
    },
    { headerName: 'Registration Date', field: 'registrationDate' },
    { headerName: 'Created On', field: 'createdOn', width: gc.DATE_FIELD_WIDTH },
    { headerName: 'Created By', field: 'createdBy' },
    { headerName: 'Modified On', field: 'modifiedOn', width: gc.DATE_FIELD_WIDTH },
    { headerName: 'Modified By', field: 'modifiedBy' },
  ];

  const gridOptions = {};

  const getAllQaUsersAsync = async () => {
    try {
      const data = await getAllQaUsers();
      setGridData(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllQaUsersAsync();
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <AgGrid
        gridData={gridData}
        gridOptions={gridOptions}
        columnDefs={columnDefinitions}
        showCreateButton={true}
        redirectOnClick={true}
        editOnClick={false}
      />
    </div>
  );
});
